import api from '@/api'

const state = {
  hostMap: {}
}

const mutations = {
  setHostMap (state, data) {
    state.hostMap = data
  }
}

const actions = {
  listWithWarehouseByCity ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listWithWarehouseByCity(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/public/listWithWarehouseByCity', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/public/listWithWarehouseByCity', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },

  getEmbedUrls ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getEmbedUrls().then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          commit('setHostMap', resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/public/getEmbedUrls', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/public/getEmbedUrls', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listSupplierClass () {
    return new Promise((resolve, reject) => {
      api.listSupplierClass().then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/public/listSupplierClass', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/public/listSupplierClass', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listClass2ByClass1 ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listClass2ByClass1(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/public/listClass2', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/public/listClass2', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listSupplierCity () {
    return new Promise((resolve, reject) => {
      api.listSupplierCity().then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/public/listSupplierCity', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/public/listSupplierCity', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/swebPublic.js